<template>
	<div
		class="mt-4 mb-4"
		style="display: flex; gap: 130px"
	>
		<div class="ao-h4 mb-1 text-textSecondary700">
			{{ label }}
		</div>
		<input
			:value="modelValue"
			type="color"
			:disabled="disabled"
			@change="$emit('update:modelValue', $event.target.value)"
		>
	</div>
	<div class="v-input__details pa-0 mt-n4 text-error">
		<div class="v-messages "
			style="opacity: 1.0">
			<div
				v-if="error && errorMessages"
				class="v-messages__message"
			>
				<span v-if="!Array.isArray(errorMessages)">{{ errorMessages }}</span>
				<span v-else-if="!Array.isArray(errorMessages[0])">{{ errorMessages[0] }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AoColorInput',

	components: {},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		modelValue: {
			type: [String, Number],
		},
		label: {
			type: String,
			default: 'color',
		},
		error: {
			type: Boolean,
			default: false,
		},
		errorMessages: {
			type: Array,
			default: () => [],
		},
	},

	emits: ['update:modelValue'],

	data: () => ({
		color: null,
		//data
	}),
	created() {},
}
</script>

<style lang="scss"></style>
